// @flow

import { type Node } from 'react';
import { useQuery } from '@apollo/react-hooks';

import query from './PartnerQuery.graphql';
import { type GetPartnerQueryRenderProps, type PartnerQueryResult } from './types';

type Props = {
  children: (renderProps: GetPartnerQueryRenderProps) => Node,
  widgetSettings: {
    partnerId: string,
  },
};

export default function PartnerDataQuery(props: Props) {
  const {
    children,
    widgetSettings: { partnerId },
  } = props;

  const { loading, data }: PartnerQueryResult = useQuery(query, {
    variables: { partnerId },
    skip: partnerId == null,
    displayName: 'withPartnerData',
  });

  const partner = data && data.partner;
  const widgetSettingsData = { ...props.widgetSettings, partnerData: { partner, loading } };

  return children({
    widgetSettingsData,
  });
}
